import axios from 'axios';
import { getSpamAlertState, setSpamAlertState } from './spamAlertState';

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      error.response.status === 429 &&
      !getSpamAlertState()
    ) {
      setSpamAlertState(true);

      // ✅ Use server-provided message if available

      //console.warn("🚨 429 Rate Limit Triggered:");
      //console.warn("🔗 URL:", error.config?.url);
      //console.warn("📦 Response Data:", error.response?.data);
      //console.warn("📋 Headers:", error.response?.headers);

      const data = error.response?.data;
      
      const serverMessage =
      (typeof data === 'string' && data) || // ← catch plain string message
      data?.error ||
      data?.message ||
      "You're too fast. Please slow down.";

      alert(serverMessage);

      setTimeout(() => setSpamAlertState(false), 5000);
    }

    return Promise.reject(error);
  }
);
